// Literal classes so Tailwind's content scanner keeps them (a dynamic `text-${align}`
// gets purged and silently drops the alignment).
const alignClass = { left: 'text-left', center: 'text-center', right: 'text-right' };

const Table = ({ children, className = '', ...props }) => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-card overflow-hidden">
    <div className="overflow-x-auto">
      <table className={`w-full ${className}`} {...props}>{children}</table>
    </div>
  </div>
);

Table.Header = ({ children, className = '' }) => <thead className={`bg-gray-50 border-b border-gray-100 ${className}`}>{children}</thead>;
Table.Body = ({ children, className = '' }) => <tbody className={`divide-y divide-gray-100 ${className}`}>{children}</tbody>;
Table.Row = ({ children, className = '', hoverable = true, ...props }) => <tr className={`${hoverable ? 'hover:bg-gray-50 transition-colors' : ''} ${className}`} {...props}>{children}</tr>;
Table.Head = ({ children, className = '', align = 'left', ...props }) => <th className={`${alignClass[align] || alignClass.left} text-xs font-semibold text-gray-500 uppercase tracking-wide px-6 py-3 ${className}`} {...props}>{children}</th>;
Table.Cell = ({ children, className = '', align = 'left', ...props }) => <td className={`${alignClass[align] || alignClass.left} px-6 py-4 text-sm text-gray-900 ${className}`} {...props}>{children}</td>;
Table.Empty = ({ children, colSpan, className = '' }) => <tr><td colSpan={colSpan} className={`px-6 py-12 text-center text-gray-500 ${className}`}>{children || 'No data available'}</td></tr>;

export default Table;
